import type { CSSProperties } from 'react';
import { placementInsets, type LegacyVideoPresentation } from '../../../renderer/src/video-presentation';
import { presentationAppearance } from '../../../renderer/src/presentation-appearance';

/** Additional room for the ordinary Reels action rail, inside the published guide. */
export function presentationStyle(presentation: LegacyVideoPresentation): CSSProperties {
  const insets = placementInsets(presentation.target, window.innerWidth, window.innerHeight);
  const hasRail = presentation.target === 'instagram-reels'
    || (presentation.target === 'instagram-feed' && window.innerWidth / window.innerHeight < .6);
  const appearance = presentationAppearance(presentation);
  return { '--plate-opacity': 1 - appearance.plateTransparency / 100, '--info-color': appearance.textColor,
    '--safe-top': insets.top, '--safe-bottom': insets.bottom, '--safe-left': insets.left,
    '--safe-right': hasRail ? Math.max(insets.right, .14) : insets.right,
    '--title-scale': presentation.titleScale / 100, '--statistics-scale': presentation.statisticsScale / 100,
  } as CSSProperties;
}
